/* unplugin-vue-components disabled */import script from "./ResourceBaseCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceBaseCard.vue?vue&type=script&setup=true&lang=ts"

import "./ResourceBaseCard.vue?vue&type=style&index=0&id=7bd69d48&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户广西-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bd69d48"]])

export default __exports__